<template>
  <div id="customer-dashboard">
    <TotalMemberCount />
    <NewOnboardSystem />
    <!-- <WarrantyExpiration /> -->
  </div>
</template>

<script>
import NewOnboardSystem from '@shared/components/customer/NewOnboardSystem.vue';
import WarrantyExpiration from '@shared/components/customer/WarrantyExpiration.vue';
import TotalMemberCount from '@shared/components/customer/TotalMemberCount.vue';

export default {
  name: 'CustomerDashboard',
  components: {
    NewOnboardSystem,
    WarrantyExpiration,
    TotalMemberCount,
  },
};
</script>

<style lang="scss">

#customer-dashboard {
  display: flex;
  align-items: center;
  height: 100%;
  @media (max-width: 1400px) {
    font-size: 90%;
  }
  @media (min-width: 1700px) {
    font-size: 110%;
  }
  .card-container {
    display: grid;
    grid-auto-flow: column;
    justify-content: space-between;
    align-items: center;
    width: 300px;
    height: 100px;
    background-color: $N100;
    margin-right: 20px;
    border-radius: 4px;
    padding: 8px 12px;
    .c-header-container {
      display: flex;
      flex-direction: column;
      .c-header {
        color: $N20;
        font-size: 0.825rem;
        font-weight: 600;
      }
    }
    .c-count-container {
      display: flex;
      align-items: flex-end;
    }
    .c-count {
      font-size: 1.5em;
      line-height: 1.25em;
      color: #FFFFFF;
    }
    .c-number-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      .c-number {
        font-size: 2em;
        font-weight: 600;
        line-height: 1em;
        color: #FFFFFF;
      }
    }
  }
}
</style>
